import '../styles/ChartBox.scss';

export default function ChartBox({ title, children }: { title: string, children: React.ReactNode }) {
  return (
    <div className="chart-box">
      <div className="chart-box-header">
        <h5>{title}</h5>
      </div>
      <div className="chart-box-content">
        {children}
      </div>
    </div>
  )
}